import { Typography } from "antd";
import { useNavigate } from "react-router-dom";
import "./journal-section-nav-title.scss";

type JournalSectionNavTitleProps = {
  recordsTitle: string;
  recordsPath: string;
  activeTab: "records" | "personnel";
};

export const JournalSectionNavTitle = ({
  recordsTitle,
  recordsPath,
  activeTab,
}: JournalSectionNavTitleProps) => {
  const navigate = useNavigate();

  return (
    <div className="journal-section-nav-title">
      {activeTab === "records" ? (
        <>
          <Typography.Title level={3} className="journal-section-nav-title__primary">
            {recordsTitle}
          </Typography.Title>
          <button
            type="button"
            className="journal-section-nav-title__link"
            onClick={() => navigate(`${recordsPath}personnel/`)}
          >
            Подписанты и Ответственные
          </button>
        </>
      ) : (
        <>
          <button
            type="button"
            className="journal-section-nav-title__link"
            onClick={() => navigate(recordsPath)}
          >
            {recordsTitle}
          </button>
          <Typography.Title level={3} className="journal-section-nav-title__primary">
            Подписанты и Ответственные
          </Typography.Title>
        </>
      )}
    </div>
  );
};
